import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	RestrictedAccessCheckSessionInfoQuery,
	RestrictedAccessCheckSessionInfoQueryVariables,
} from './api.graphql';
import { RestrictedAccessCheckSessionInfo } from './api.graphql';

type Result = RestrictedAccessCheckSessionInfoQuery['viewer'];

export async function getRestrictedAccessCheckSessionInfo({ gql: { fetch } }: UtilityContext): Promise<Result> {
	const { data } = await fetch<RestrictedAccessCheckSessionInfoQuery, RestrictedAccessCheckSessionInfoQueryVariables>({
		query: RestrictedAccessCheckSessionInfo,
		batched: false,
		rejectOnError: true,
	});
	return data.viewer;
}
